import productsApi from '../api/products';
import {
  UPLOAD_PRODUCT_UPDATE_TEMPLATE_FILE,
  UPLOAD_BOOKKEEPING_FILE,
  GENERATE_PRODUCTS_TABLE_BEGIN,
  GENERATE_PRODUCTS_TABLE_SUCCESS,
  GENERATE_PRODUCTS_TABLE_FAILURE,
  SET_PRODUCTS_TABLE_DATA,
  SAVE_PRODUCTS_CHANGES_BEGIN,
  SAVE_PRODUCTS_CHANGES_SUCCESS,
  SAVE_PRODUCTS_CHANGES_FAILURE,
  SET_GENERATED_UPDATE_ENTITY_ID,
  DOWNLOAD_PRODUCT_UPDATE_FILES_BEGIN,
  DOWNLOAD_PRODUCT_UPDATE_FILES_SUCCESS,
  DOWNLOAD_PRODUCT_UPDATE_FILES_FAILURE,
  GET_PRODUCT_UPDATE_BARCODES_BEGIN,
  GET_PRODUCT_UPDATE_BARCODES_SUCCESS,
  GET_PRODUCT_UPDATE_BARCODES_FAILURE,
  SET_UPDATED_PRODUCTS_BARCODES_DATA,
  GET_SUMMARY_REPORT_TABLE_BEGIN,
  GET_SUMMARY_REPORT_TABLE_FAILURE,
  GET_SUMMARY_REPORT_TABLE_SUCCESS,
  SET_SUMMARY_REPORT_TABLE_DATA,
  OPEN_DETAILS_TABLE_IN_WINDOW,
  CLOSE_DETAILS_TABLE_WINDOW,
  OPEN_SUMMARY_TABLE_IN_WINDOW,
  CLOSE_SUMMARY_TABLE_WINDOW,
  SET_SUPERUSER,
  SET_PRODUCT_CHANGES,
} from './types';


export default {
  namespaced: true,
  state: {
    bookKeepingFile: null,
    productUpdateTemplateFile: null,
    bookKeepingFileUploadedId: null,
    productUpdateTemplateFileUploadedId: null,
    productsTableData: [],
    categoriesForFilter: [],
    suppliersForFilter: [],
    generatingTable: false,
    generatedTable: false,
    tableGenerationError: false,
    savingChanges: false,
    savedChanges: false,
    changesSavingError: false,
    generatedUpdateEntityId: null,
    downloadingProductUpdateFiles: false,
    downloadedProductUpdateFiles: false,
    downloadProductUpdateFilesError: false,
    gettingProductUpdateBarcodes: false,
    getProductUpdateBarcodesSuccess: false,
    getProductUpdateBarcodesError: false,
    updatedProductsBarcodesData: null,
    gettingSummaryReportTable: false,
    receivedSummaryReportTable: false,
    summaryReportTableGenerationError: false,
    summaryReportTableData: [],
    summaryReportAggregateBy: null,
    productsDetailsTableWindowOpen: false,
    summaryReportTableWindowOpen: false,
    excelExportData: [],
    excelExportProductData: [],
  },
  actions: {
    uploadBookkeepingFile({ commit }, file) {
      commit(UPLOAD_BOOKKEEPING_FILE, file);
    },
    uploadProductUpdateTemplate({ commit }, file) {
      commit(UPLOAD_PRODUCT_UPDATE_TEMPLATE_FILE, file);
    },
    generateTable({ commit }, currentLocationId) {
      commit(GENERATE_PRODUCTS_TABLE_BEGIN);
      if (currentLocationId == null) {
        currentLocationId = 0
      }
      return productsApi.generateTable(currentLocationId)
        .then(({ data }) => commit(SET_PRODUCTS_TABLE_DATA, data['data']))
        .then(() => commit(GENERATE_PRODUCTS_TABLE_SUCCESS))
        .catch((e) => commit(GENERATE_PRODUCTS_TABLE_FAILURE));
    },
    saveChanges({ commit, dispatch }, changes) {
      commit(SAVE_PRODUCTS_CHANGES_BEGIN);
      return productsApi.saveChanges(changes)
        .then(({ data }) => commit(SET_GENERATED_UPDATE_ENTITY_ID, data['data']['generated_update_entity_id']))
        .then(() => commit(SAVE_PRODUCTS_CHANGES_SUCCESS))
        .then(() => dispatch('downloadUpdateFiles'))
        .then(() => dispatch('getUpdatedProductsBarcodesData'))
        .catch(() => commit(SAVE_PRODUCTS_CHANGES_FAILURE));
    },
    downloadUpdateFiles({ commit, state }) {
      commit(DOWNLOAD_PRODUCT_UPDATE_FILES_BEGIN);
      return productsApi.downloadProductUpdateFiles(state.generatedUpdateEntityId)
        .then(() => commit(DOWNLOAD_PRODUCT_UPDATE_FILES_SUCCESS))
        .catch(() => commit(DOWNLOAD_PRODUCT_UPDATE_FILES_FAILURE));
    },
    getUpdatedProductsBarcodesData({ commit }, updateEntityId) {
      commit(GET_PRODUCT_UPDATE_BARCODES_BEGIN);
      return productsApi.getProductUpdateBarcodes(updateEntityId)
        .then(({ data }) => commit(SET_UPDATED_PRODUCTS_BARCODES_DATA, data['data']))
        .then(() => commit(GET_PRODUCT_UPDATE_BARCODES_SUCCESS))
        .catch(() => commit(GET_PRODUCT_UPDATE_BARCODES_FAILURE));
    },
    getSummaryReportTable({ commit }, {aggregateBy, timeFrame, currentLocationId}) {
      commit(GET_SUMMARY_REPORT_TABLE_BEGIN);
      if (currentLocationId == null) {
        currentLocationId = 0
      }
      return productsApi.getSummaryReportTable(aggregateBy, timeFrame, currentLocationId)
        .then(({ data }) => commit(SET_SUMMARY_REPORT_TABLE_DATA, {data: data['data'], aggregateBy: aggregateBy}))
        .then(() => commit(GET_SUMMARY_REPORT_TABLE_SUCCESS))
        .catch((e) => commit(GET_SUMMARY_REPORT_TABLE_FAILURE));
    },
    openDetailsTableInWindow({ commit }) {
      commit(OPEN_DETAILS_TABLE_IN_WINDOW);
    },
    closeDetailsTableWindow({ commit }) {
      commit(CLOSE_DETAILS_TABLE_WINDOW);
    },
    openSummaryTableInWindow({ commit }) {
      commit(OPEN_SUMMARY_TABLE_IN_WINDOW);
    },
    closeSummaryTableWindow({ commit }) {
      commit(CLOSE_SUMMARY_TABLE_WINDOW);
    },
    saveProductChanges ({ commit }, changes) {
    return productsApi.saveProductChanges(changes)
      .then(response => {
        const message = response.data.message;
        commit('SET_PRODUCT_CHANGES', changes);
        if (message != 'Products updated successfully') {
          const errorMessage = response.data.message;
          alert('Failed to update database: ' + errorMessage);
        }
      })
      .catch(error => {
          console.error(error);
          alert('Failed to update database');
        });
    }
  },
  mutations: {
     [SET_PRODUCT_CHANGES] (state, changes) {
      state.productChanges = changes
    },
    [GENERATE_PRODUCTS_TABLE_BEGIN](state) {
      state.generatingTable = true;
      state.tableGenerationError = false;
      state.savingChanges = false;
      state.changesSavingError = false;
    },
    [GENERATE_PRODUCTS_TABLE_FAILURE](state) {
      state.generatingTable = false;
      state.generatedTable = false;
      state.tableGenerationError = true;
      state.savedChanges = false;
    },
    [GENERATE_PRODUCTS_TABLE_SUCCESS](state) {
      state.generatingTable = false;
      state.generatedTable = true;
      state.tableGenerationError = false;
    },
    [SET_PRODUCTS_TABLE_DATA](state, data) {
      state.productsTableData = data.sort(function(el1, el2) {
        const product1NameNormalized = el1['Product Name'].trim().toLowerCase();
        const product2NameNormalized = el2['Product Name'].trim().toLowerCase();
        const char1 = product1NameNormalized.split(' ')[0][0];
        const char2 = product2NameNormalized.split(' ')[0][0];
        if (char1 != char2) {
          return char1 > char2 ? 1 : -1;
        }
        return product1NameNormalized.localeCompare(product2NameNormalized);
      });

      state.excelExportProductData = state.productsTableData.map(detailed => ({
        'Product ID': detailed.ProductID,
        'Name': detailed['Product Name'],
        'Description': detailed['Product Description'],
        'Barcode': detailed.Barcode,
        'Category Group': detailed['Category Name'],
        'Supplier Group': detailed.Supplier,
        'Cost Price (Ex VAT)': detailed['Cost Price'],
        'Selling Price (Inc VAT)': detailed['Selling Price'],
        'Markup': detailed.MarginPercent,
        'This month sales': detailed.ThisMonthSales,
        'This month sales Values': detailed.ThisMonthSalesValues,
        'Last month sales': detailed.LastMonthSales,
        'Last month sales Values': detailed.LastMonthSalesValues,
        'Month pre last sales': detailed.MonthBeforeLastSales,
        'Month pre last sales Values': detailed.MonthBeforeLastSalesValues,
        'Last 12 Months Sales': detailed.Last12MonthsSales,
        'Last 12 Months Sales Values': detailed.Last12MonthsSalesValues,
        'Tax Percentage': detailed['Tax Percentage'],
        'Updated': detailed.Updated,
        'RRP': detailed.RRP
      }))

      let setCategory = new Set();
      let setSupplier = new Set();
      let categoriesDataList = new Array();
      let suppliersDataList = new Array();
      for (const row of data) {
        setCategory.add(row['Category Name']);
        setSupplier.add(row['Supplier']);
        if (Number(row.MarginPercent) < 0) {
          row.$rowStyle = { borderTop: '1px solid red', borderBottom: '1px solid red' };
        }
      }
      for (const category of setCategory) {
        categoriesDataList.push({category})
      }
      for (const supplier of setSupplier) {
        suppliersDataList.push({supplier})
      }
      categoriesDataList.sort(function (a, b) {
        return String(a.category).localeCompare(String(b.category));
      });
      suppliersDataList.sort(function (a, b) {
        return String(a.supplier).localeCompare(String(b.supplier));
      });
      state.categoriesForFilter = categoriesDataList;
      state.suppliersForFilter = suppliersDataList;
    },
    [SAVE_PRODUCTS_CHANGES_BEGIN](state) {
      state.savingChanges = true;
      state.changesSavingError = false;
    },
    [SAVE_PRODUCTS_CHANGES_FAILURE](state) {
      state.savingChanges = false;
      state.savedChanges = false;
      state.changesSavingError = true;
      state.generatedUpdateEntityId = null;
    },
    [SAVE_PRODUCTS_CHANGES_SUCCESS](state) {
      state.savingChanges = false;
      state.savedChanges = true;
      state.changesSavingError = false;
    },
    [SET_GENERATED_UPDATE_ENTITY_ID](state, data) {
      state.generatedUpdateEntityId = data;
    },
    [DOWNLOAD_PRODUCT_UPDATE_FILES_BEGIN](state) {
      state.downloadingProductUpdateFiles = true;
      state.downloadProductUpdateFilesError = false;
    },
    [DOWNLOAD_PRODUCT_UPDATE_FILES_FAILURE](state) {
      state.downloadingProductUpdateFiles = false;
      state.downloadedProductUpdateFiles = false;
      state.downloadProductUpdateFilesError = true;
    },
    [DOWNLOAD_PRODUCT_UPDATE_FILES_SUCCESS](state) {
      state.downloadingProductUpdateFiles = false;
      state.downloadedProductUpdateFiles = true;
      state.downloadProductUpdateFilesError = false;
    },
    [GET_PRODUCT_UPDATE_BARCODES_BEGIN](state) {
      state.gettingProductUpdateBarcodes = true;
      state.getProductUpdateBarcodesError = false;
    },
    [GET_PRODUCT_UPDATE_BARCODES_FAILURE](state) {
      state.gettingProductUpdateBarcodes = false;
      state.getProductUpdateBarcodesSuccess = false;
      state.getProductUpdateBarcodesError = true;
    },
    [GET_PRODUCT_UPDATE_BARCODES_SUCCESS](state) {
      state.gettingProductUpdateBarcodes = false;
      state.getProductUpdateBarcodesSuccess = true;
      state.getProductUpdateBarcodesError = false;
    },
    [SET_UPDATED_PRODUCTS_BARCODES_DATA](state, data) {
      state.updatedProductsBarcodesData = data;
    },
    [UPLOAD_BOOKKEEPING_FILE](state, file) {
      state.bookKeepingFile = file;
    },
    [UPLOAD_PRODUCT_UPDATE_TEMPLATE_FILE](state, file) {
      state.productUpdateTemplateFile = file;
    },
    [GET_SUMMARY_REPORT_TABLE_BEGIN](state) {
      state.gettingSummaryReportTable = true;
      state.summaryReportTableGenerationError = false;
    },
    [GET_SUMMARY_REPORT_TABLE_FAILURE](state) {
      state.gettingSummaryReportTable = false;
      state.receivedSummaryReportTable = false;
    },
    [GET_SUMMARY_REPORT_TABLE_SUCCESS](state) {
      state.gettingSummaryReportTable = false;
      state.receivedSummaryReportTable = true;
      state.summaryReportTableGenerationError = false;
    },
    [SET_SUMMARY_REPORT_TABLE_DATA](state, {data, aggregateBy}) {
      let fieldName;
      if (aggregateBy === 'category') fieldName = 'Product Category';
      if (aggregateBy === 'supplier') fieldName = 'Supplier';
      state.summaryReportTableData = data.sort(function(el1, el2) {
        const name1Normalized = String(el1[fieldName]).trim().toLowerCase();
        const name2Normalized = String(el2[fieldName]).trim().toLowerCase();
        const char1 = name1Normalized.split(' ')[0][0];
        const char2 = name2Normalized.split(' ')[0][0];
        if (char1 != char2) {
          return char1 > char2 ? 1 : -1;
        }
        return name1Normalized.localeCompare(name2Normalized);
      });
      //state.summaryReportTableData = data;
      state.summaryReportAggregateBy = aggregateBy;

      if (localStorage.getItem('SET_SUPERUSER') === 'true') {
        state.excelExportData = state.summaryReportTableData.map(detailed => ({
          [fieldName] : detailed[fieldName],
          'Total £ sales this Month': detailed.ThisMonthSales,
          'MKUP this month': detailed.ThisMonthMargin,
          'Profit this month': detailed.ThisMonthProfit,
          'Total £ sales this month last year': detailed.ThisMonthLastYearSales,
          'MKUP this month last year': detailed.ThisMonthLastYearMargin,
          'Profit this month last year': detailed.ThisMonthLastYearProfit,
          'Total £ sales year to date': detailed.YearToDateSales,
          'MKUP year to date': detailed.YearToDateMargin,
          'Profit year to date': detailed.YearToDateProfit,
          'Total £ sales last year': detailed.LastYearSales,
          'MKUP last year': detailed.LastYearMargin,
          'Profit last year': detailed.LastYearProfit
      }))}
      else {
        state.excelExportData = state.summaryReportTableData.map(detailed => ({
          [fieldName] : detailed[fieldName],
          'Total £ sales this Month': detailed.ThisMonthSales,
          'MKUP this month': detailed.ThisMonthMargin,
          'Total £ sales this month last year': detailed.ThisMonthLastYearSales,
          'MKUP this month last year': detailed.ThisMonthLastYearMargin,
          'Total £ sales year to date': detailed.YearToDateSales,
          'MKUP year to date': detailed.YearToDateMargin,
          'Total £ sales last year': detailed.LastYearSales,
          'MKUP last year': detailed.LastYearMargin,
      }))
      };
    },
    [OPEN_DETAILS_TABLE_IN_WINDOW](state) {
      state.productsDetailsTableWindowOpen = true;
    },
    [CLOSE_DETAILS_TABLE_WINDOW](state) {
      state.productsDetailsTableWindowOpen = false;
    },
    [OPEN_SUMMARY_TABLE_IN_WINDOW](state) {
      state.summaryReportTableWindowOpen = true;
    },
    [CLOSE_SUMMARY_TABLE_WINDOW](state) {
      state.summaryReportTableWindowOpen = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/products.js